/**
 * Kamuni Collection Context Tracker - Híbrido para sistema de tags + contexto
 * Rastrea la navegación para complementar el sistema de tags
 */

(function() {
  'use strict';

  const WHOLESALE_COLLECTIONS = [
    'marquillos-linea-mapri',
    'marquillos'
  ];

  const STORAGE_KEY = 'kamuni_collection_context';
  const CONTEXT_DURATION = 5 * 60 * 1000; // 5 minutos

  /**
   * Guarda el contexto de navegación en sessionStorage
   */
  function saveCollectionContext(collectionHandle) {
    const context = {
      collectionHandle: collectionHandle,
      timestamp: Date.now(),
      isWholesale: WHOLESALE_COLLECTIONS.includes(collectionHandle)
    };
    
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context));
    } catch (e) {
      console.warn('Kamuni: No se pudo guardar contexto:', e);
    }
  }

  /**
   * Obtiene el contexto de navegación
   */
  function getCollectionContext() {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      if (!stored) return null;

      const context = JSON.parse(stored);
      const now = Date.now();

      // Verificar si el contexto no ha expirado
      if (now - context.timestamp > CONTEXT_DURATION) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return context;
    } catch (e) {
      console.warn('Kamuni: Error al leer contexto:', e);
      return null;
    }
  }

  /**
   * Detecta si estamos en una página de colección y guarda el contexto
   */
  function detectAndSaveCollectionContext() {
    const path = window.location.pathname;
    
    // Verificar si estamos en una página de colección
    const collectionMatch = path.match(/\/collections\/([^\/]+)/);
    if (collectionMatch) {
      const collectionHandle = collectionMatch[1];
      saveCollectionContext(collectionHandle);

      return collectionHandle;
    }
    
    return null;
  }

  /**
   * En página de producto, verifica el contexto y envía evento
   */
  function checkProductContext() {
    const path = window.location.pathname;
    
    // Solo en páginas de producto
    if (!path.includes('/products/')) return;

    const context = getCollectionContext();
    if (context && context.isWholesale) {
    
      
      // Enviar evento para notificar al wholesale handler
      const event = new CustomEvent('kamuniCollectionContext', {
        detail: {
          isWholesale: true,
          collectionHandle: context.collectionHandle,
          timestamp: context.timestamp
        }
      });
      
      document.dispatchEvent(event);
    }
  }

  /**
   * Rastrea clics en enlaces a productos desde colecciones
   */
  function trackProductLinks() {
    document.addEventListener('click', function(event) {
      const link = event.target.closest('a[href*="/products/"]');
      if (!link) return;

      const currentPath = window.location.pathname;
      const collectionMatch = currentPath.match(/\/collections\/([^\/]+)/);
      
      if (collectionMatch) {
        const collectionHandle = collectionMatch[1];
        saveCollectionContext(collectionHandle);
      }
    });
  }

  /**
   * Inicializar el tracker
   */
  function init() {
    // Si estamos en una colección, guardar contexto
    detectAndSaveCollectionContext();
    
    // Si estamos en un producto, verificar contexto
    checkProductContext();
    
    // Rastrear clics en productos
    trackProductLinks();
  }

  /**
   * Función para forzar contexto wholesale (para debugging)
   */
  function setWholesaleState(force = true) {
    if (force) {
      saveCollectionContext('marquillos-linea-mapri');
      
      // Enviar evento inmediatamente
      const event = new CustomEvent('kamuniCollectionContext', {
        detail: {
          isWholesale: true,
          collectionHandle: 'marquillos-linea-mapri',
          timestamp: Date.now()
        }
      });
      
      document.dispatchEvent(event);
      return true;
    }
    return false;
  }

  // Ejecutar cuando esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Exponer para debugging y compatibilidad
  window.KamuniCollectionContext = {
    get: getCollectionContext,
    set: setWholesaleState,
    save: saveCollectionContext,
    detect: detectAndSaveCollectionContext,
    track: trackProductLinks
  };

})();
